import * as React from 'react';
import { SVGProps } from 'react';

const SvgNurseAndBaby = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M10 25v5.016c0 .18.051.355.148.508.096.153.235.278.4.361.147.075.312.115.479.115.205.002.407-.055.578-.164L15.5 28.5m2.968 3.086L14.5 34.5M10.815 9.074v2.395a5.23 5.23 0 0 0 5.221 5.226 5.23 5.23 0 0 0 5.226-5.226V9.074"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M10.815 11.364v-2.4a5.225 5.225 0 0 1 10.447 0v2.4M21.5 20c-.5-.5-1.027-1.123-2.512-1.738a8.121 8.121 0 0 0-4.695-.462c-1.576.314-2.793.462-4.293 1.7-.5.333-1.7 1.3-2.5 2.5M24 31v5.1H7.5"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M21.693 9.575a9.777 9.777 0 0 1-6.584-1.702 3.779 3.779 0 0 1-.548 1.125c-.518.716-1.56 1.59-3.574 1.59"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M11.204 6.38a4.383 4.383 0 0 0-2.6-.345A5.113 5.113 0 0 0 5 10.97v6.817l1.945-1.368c.38-.266 2.96-1.777 4.055-3.919"
    />
    <circle
      cx={17.5}
      cy={29.5}
      r={2.25}
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <circle cx={28} cy={28} r={2.25} stroke="currentColor" strokeWidth={1.5} />
    <path fill={props.fill} d="M3.776 24.198v12.677h4.41V19.789l-4.41 4.41Z" />
    <path
      fill="currentColor"
      d="m31.847 18.304-1.752-1.756.348-.318a2.526 2.526 0 0 1 3.557 0l-1.756 1.756a.035.035 0 0 0-.025-.01.035.035 0 0 0-.025.01l-.347.318Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M19.5 31c1 .581 1.75.586 2.393.581a4.84 4.84 0 0 0 3.462-1.442L26.5 29m2.01-5.662.524.508c.344.346.538.815.538 1.303L29.5 26m-4.795-6.453a1.844 1.844 0 0 0-2.6 0l-3.679 3.687A4.9 4.9 0 0 0 17 26.69v.809"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M32.479 19.467a3.821 3.821 0 1 1-7.643 0 3.821 3.821 0 0 1 7.643 0Zm-14.336 3.829H29.57"
    />
  </svg>
);

export default SvgNurseAndBaby;
